<template>
  <v-container fluid style="padding: 0px;">
    <v-layout wrap>
      <v-flex xs12>
        <Subheader v-model="search" title="Units" search="Unit">
          <v-btn color="success" @click="clickAddUnit()">
            <v-icon class="mr-1">add</v-icon>{{ $t('Button.AddUnit') }}
          </v-btn>
        </Subheader>
        <v-card>
          <v-card-text>
            <v-data-table :headers="headers" :items="allUnits" :pagination.sync="pagination" :search="search">
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.Name }}</td>
                <td class="text-xs-left" v-html="getThisUnitGroupName(props.item.Groups).toString()"></td>
                <td class="text-xs-right">
                  <v-btn dark color="warning" @click="clickEditUnit(props.item)">
                    <v-icon class="mr-1">edit</v-icon>{{ $t('Button.Edit') }}
                  </v-btn>
                  <!-- <v-btn dark color="primary" @click="clickConvert(props.item)">Convert</v-btn> -->
                  <v-btn dark color="delete" @click="clickDeleteUnit(props.item)">
                    <v-icon class="mr-1">delete_forever</v-icon>{{ $t('Button.Remove') }}
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>


    <app-modal v-model="addDialog" persistent max-width="800">
      <template v-slot:title>{{ $t('UnitDetailManage.addTitle') }}</template>
      <template v-slot:text>
        <v-layout wrap>
          <v-flex xs12 pl-3 pr-3>
            <v-text-field label="Unit Name" v-model="unitData.unitName" required></v-text-field>
          </v-flex>
          <v-flex xs12 pl-3 pr-3>
            <v-autocomplete label="Unit Group" v-bind:items="allUnitGroups" v-model="unitData.belongToGroup" multiple hint="Pick belong to Unit Group" persistent-hint item-text="Name" item-value="Id">
            </v-autocomplete>
          </v-flex>
        </v-layout>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="clickSaveUnit()">
          <v-icon>done</v-icon>{{ $t('Button.Save') }}
        </v-btn>
        <v-btn color="secondary" @click="closeDialog()" outline>{{ $t('Button.Cancel') }}</v-btn>
      </template>
    </app-modal>

    <app-modal v-model="showEditUnit" persistent max-width="800">
      <template v-slot:title>{{ $t('UnitDetailManage.editTitle', { msg: unitDetail.Name }) }}</template>
      <template v-slot:text>
        <v-layout wrap>
          <v-flex xs12 pl-3 pr-3>
            <v-text-field label="Unit Name" v-model="unitData.unitName" required></v-text-field>
          </v-flex>
          <v-flex xs12 pl-3 pr-3>
            <v-autocomplete label="Belong To Unit Group" v-bind:items="allUnitGroups" v-model="unitData.belongToGroup" multiple hint="Pick belong to Unit Group" persistent-hint item-text="Name" item-value="Id">
            </v-autocomplete>
          </v-flex>
        </v-layout>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="clickSaveEditUnit()">
          <v-icon>done</v-icon>{{ $t('Button.Save') }}
        </v-btn>
        <v-btn color="secondary" @click="closeDialog()" outline>{{ $t('Button.Cancel') }}</v-btn>
      </template>
    </app-modal>

    <app-modal v-model="dialog" persistent max-width="800">
      <template v-slot:title>{{dialogMessage}}</template>
      <template v-slot:text>{{ $t('UnitDetailManage.deleteMsg') }}</template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn color="delete" dark @click="agreeDeleteUnit()">
          <v-icon>delete_forever</v-icon>{{ $t('Button.Remove') }}
        </v-btn>
        <v-btn color="secondary" @click="dialog = false" outline>{{ $t('Button.Cancel') }}</v-btn>
      </template>
    </app-modal>

    <v-card color="grey lighten-4">
      <v-snackbar style="text-align:left" auto-height :color="snackbar.snackbarColor" :timeout="null" top v-model="snackbar.isSnackbarShow">
        {{ snackbar.snackbarMessage }}
        <v-btn dark icon @click="hideSnackbar()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import { errorMessage } from '@/helpers/exceptionHandling'
  import MessageUtil from '../mixins/MessageUtil'
  import Subheader from '@/components/generic/Subheader'
  import AppModal from '@/components/generic/AppModal'

  const unit = createNamespacedHelpers('unit')

  export default {
    components: {
      Subheader,
      'app-modal': AppModal,
    },
    mixins: [MessageUtil],
    data() {
      return {
        search: '',
        headers: [{
          text: 'Unit',
          value: 'Name',
          align: 'left',
        },
        {
          text: 'Unit Group',
          value: 'Group',
          align: 'left',
        },
        {
          text: 'Action',
          value: null,
          align: 'right',
        },
        ],
        pagination: {
          sortBy: 'longName',
          rowsPerPage: 10,
        },
        addDialog: false,
        showFormula: false,
        disableFormula: true,
        showEditUnit: false,
        editUnitable: 1, //state 0:clear; 1:add; 2:edit
        unitId: -1,
        currentUnit: {},
        unitData: {
          unitId: null,
          unitName: '',
          belongToGroup: [],
        },
        deleteUnit: '',
        dialog: false,
        dialogMessage: '',
        dialogState: '',
      }
    },
    computed: {
      ...unit.mapGetters(['allUnitGroups', 'unitDetail', 'allUnits']),
    },
    mounted() {},
    methods: {
      ...unit.mapActions(['getUnitDetail', 'getUnitList', 'getUnitGroup', 'postAddUnit', 'postEditUnit',
        'postDeleteUnit',
        'postUnitConvert',
      ]),
      getThisUnitGroupName(GroupList) {
        let arr = []
        GroupList.forEach(e => {
          arr.push(e.Name)
        })
        return arr
      },
      enableDialog(state, message) {
        this.dialog = true
        this.dialogState = state
        this.dialogMessage = message
      },
      clickAddUnit() {
        this.emptyUnitData()
        this.editUnitable = 1
        this.unitId = -1
        this.disableFormula = !this.disableFormula
        this.addDialog = true
      },
      clickDeleteUnit(unit) {
        this.enableDialog('deleteUnit', `Are you sure to delete Unit: ${ unit.Name } ?`)
        this.deleteUnit = unit
      },
      clickSaveUnit() {
        if (this.unitData.unitName) {
          let repeat = false
          let target = this.allUnits.findIndex(e => e.Name.trim().toUpperCase() == this.unitData.unitName.trim().toUpperCase())
          if (target >= 0) {
            repeat = true
          }
          if (repeat) {
            this.showSnackbar(`Add unit request failed. Unit ${this.unitData.unitName} already exists in the system, please enter correct Unit Name.`, 'error')
          } else {
            this.agreeSaveUnit(false)
          }
        } else {
          this.showSnackbar('Add unit request failed. Unit Name cannot be null, please select Unit Name.', 'error')
        }
      },
      clickSaveEditUnit() {
        let matched = this.allUnits.find(x => x.Name.trim().toUpperCase() == this.unitData.unitName.trim().toUpperCase() 
          && x.Id != this.unitData.unitId)
        if (this.unitData.unitName) {
          if (matched) {
            this.showSnackbar(`Edit unit request failed. Unit ${this.unitData.unitName} already exists in the system, please enter correct Unit Name.`, 'error')
          } else {
            this.agreeSaveUnit(true)
          }
        } else {
          this.showSnackbar('Edit unit request failed. Unit Name cannot be null, please select Unit Name.', 'error')
        }
      },
      clickEditUnit(unit) {
        this.showEditUnit = true
        this.emptyUnitData()
        this.unitData.unitId = unit.Id
        this.unitData.unitName = unit.Name
        let groups = []
        unit.Groups.forEach(e => {
          groups.push(e.Id)
        })
        this.unitData.belongToGroup = groups
        this.editUnitable = 2
        this.unitId = unit.Id
        this.currentUnit = unit
        this.getUnitDetail(unit.Id)
      },
      clickConvert(options) {
        this.getUnitDetail(options.Id)
        this.$router.push({
          name: 'UnitDetail',
          params: {
            unit: options,
          },
        })
      },
      agreeSaveUnit(isEdit) {
        this.dialog = false
        this.addDialog = false
        this.showEditUnit = false
        let options = {
          data: this.unitData,
          successCb: () => {
            if (isEdit) {
              this.showSnackbar(`Unit: ${ this.unitData.unitName } is edited successfully`, 'success')
            } else {
              this.showSnackbar(`Unit: ${ this.unitData.unitName } is added successfully`, 'success')
            }
          },
          failedCb: (err) => {
            if (isEdit) {
              this.showSnackbar(`Edit unit request failed. ${errorMessage(err)}`, 'error')
            } else {
              this.showSnackbar(`Add unit request failed. ${errorMessage(err)}`, 'error')
            }
          },
        }
        if (this.unitData.unitId) {
          this.postEditUnit(options)
        } else {
          this.postAddUnit(options)
        }
      },
      agreeDeleteUnit() {
        this.dialog = false
        let options = {
          data: this.deleteUnit.Id,
          successCb: () => {
            this.showSnackbar(`Unit: ${ this.deleteUnit.Name } is removed successfully.`, 'success')
          },
          failedCb: (err) => {
            this.showSnackbar(`Delete unit request failed. ${errorMessage(err)}`, 'error')
          },
        }
        this.postDeleteUnit(options)
      },
      emptyUnitData() {
        this.unitData = {
          unitId: null,
          unitName: '',
          belongToGroup: [],
        }
      },
      closeDialog() {
        this.addDialog = false
        this.showEditUnit = false
      },
    },
  }
</script>